import { render, staticRenderFns } from "./ConfirmDates.vue?vue&type=template&id=530545f8&scoped=true&"
import script from "./ConfirmDates.vue?vue&type=script&lang=js&"
export * from "./ConfirmDates.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmDates.vue?vue&type=style&index=0&id=530545f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530545f8",
  null
  
)

export default component.exports